import ExamImageComponent from '../ExamImageComponent';
import GridCornerHeader from './GridCornerHeader';
import GridCornerLayer from './GridCornerLayer';
import GridCornerProvider from './GridCornerProvider';

function ExamImageGridCornerField(props) {
	return (
		<GridCornerProvider>
			<ExamImageComponent {...props} HeaderComponent={GridCornerHeader} LayerComponent={GridCornerLayer} />
		</GridCornerProvider>
	);
}
export default ExamImageGridCornerField;
